module.exports = __webpack_public_path__ + "static/map.e34ff18f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/map.png
// module id = 299
// module chunks = 2